import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap';
import { Cache } from 'aws-amplify';
import { FINANCE_APPROVER, setDefaultRole }  from '../../store/actions/users/usersActions';

import { getProject, resetProject, resetPlatformBands } from '../../store/actions/projects/projectsActions';
import { getAuditTrail, resetForApproval } from '../../store/actions/audit_trail/projectAuditTrailActions';

import PageTitle from '../../common/PageTitle';
import CompleteDetails from './CompleteDetails';
import ProjectApprovalButtons from './ProjectApprovalButtons';


class ForApproval extends Component {

  constructor(props) {
    super(props);
    this.projectId = 0;
  }

  componentDidMount() {
    const currentUser = this.props.users.currentUser;
    let roleId = Cache.getItem('roleId');

    const urlParams = new URLSearchParams(this.props.location.search);
    const projectId =  urlParams.get('id');
    const paramRoleId = urlParams.get('role_id');
    
    if (paramRoleId && roleId !== +paramRoleId) {
      let role =  null; 

      if (currentUser && typeof(currentUser.roles) !== "undefined") {
        const userRoles = currentUser.roles;
        
        userRoles.length && userRoles.filter(data => {
          if (data.id === +paramRoleId) {
            return data;
          }
          return false;
        }).forEach(userRole => {
          role = userRole;
        })
      }

      if (role) {
        this.props.setDefaultRole(role);
        roleId = +paramRoleId; 
      }
    }

    const allowedRoles = [
      FINANCE_APPROVER,
    ];
    
    if (!allowedRoles.includes(roleId)) {
      this.props.history.push('/');
    }

    this.props.getProject(projectId, true, true);
    this.props.getAuditTrail(projectId);
    this.projectId = projectId;
    
  }

  componentWillUnmount() {
    this.props.resetProject();
    this.props.resetPlatformBands();
    this.props.resetForApproval();
  }
  
  render() {
    const newDetails = this.props.projects.forApproval;
    const oldDetails = this.props.projects.project;
    const userId = Cache.getItem('userId');

    if (!Object.keys(newDetails).length) {
      return "Loading...";
    }

    if (!oldDetails 
      || !oldDetails.project_approvers
      || !oldDetails.project_approvers.map(approver => approver.approver_id).includes(userId)) {
      return '';
    }

    return (
      <>
        <PageTitle pageName={"For Approval: " + newDetails.project_name} />
        <CompleteDetails project={newDetails} newDetails={newDetails} oldDetails={oldDetails} forApproval={true} />
        <Row className="mt-5">
          <Col>
            <div className="float-right">
              <Button variant="default" onClick={() => {
                this.props.history.push('/approvals');
              }}>Cancel</Button>
              <ProjectApprovalButtons project={newDetails} inPage={true} />
            </div>
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  projects: state.projects,
  users: state.users 
})

const mapDispatchToProps = (dispatch) => {
  return {
    getProject: (...args) => dispatch(getProject(...args)),
    resetProject: () => dispatch(resetProject()),
    resetPlatformBands: () => dispatch(resetPlatformBands()),
    getAuditTrail: (...args) => dispatch(getAuditTrail(...args)),
    resetForApproval: () => dispatch(resetForApproval()),
    setDefaultRole: (...args) => dispatch(setDefaultRole(...args))
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ForApproval))